import React from 'react'
import { XeroSignInWidget } from '@/components/integrations/XeroButton'
import LockBadge from '@/components/feature-gate/LockBadge'
import { useStartXeroSignIn } from '@/services/api/auth/useXeroSignIn'
import useAuthProviders from '@/services/api/auth/useAuthProviders'

const COMING_SOON = 'Sign in with Xero is coming soon.'

export default function XeroLoginButton({
  label = 'Sign in with Xero',
}: {
  label?: string
}) {
  const { action, status } = useStartXeroSignIn()
  const { data: providers } = useAuthProviders()

  // Off unless the backend says it's on (XERO_SSO_ENABLED). Xero's own button
  // artwork stays intact, dimmed and inert, with the same "Soon" badge as
  // in-app Pro features.
  if (providers?.xero.enabled !== true) {
    return (
      <div className="w-full" aria-disabled="true" title={COMING_SOON}>
        <div className="relative">
          <div
            className="pointer-events-none select-none opacity-50"
            {...{ inert: '' }}
          >
            <XeroSignInWidget label={label} onStart={() => {}} />
          </div>
          <span className="absolute -right-1.5 -top-1.5">
            <LockBadge badge="coming_soon" tooltip={null} />
          </span>
        </div>
        <p className="mt-1 text-center text-xs text-muted-foreground">
          {COMING_SOON}
        </p>
      </div>
    )
  }

  return (
    <XeroSignInWidget
      label={label}
      onStart={() => action()}
      className={
        status.isPending || status.isSuccess
          ? 'pointer-events-none animate-pulse'
          : ''
      }
    />
  )
}
